export const CUSTOMER_SUCCESS_MESSAGE = 'Successfully Saved!';
export const CUSTOMER_ERROR_MESSAGE =
  'Oops! Something went wrong. Please try again later.';
